import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";

const ViewJobWorker = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [worker, setWorker] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchWorkerDetails();
    }
  }, [id]);

  const fetchWorkerDetails = () => {
    try {
      setLoading(true);
      setError(null);
      
      // Get data from localStorage
      const storedWorkers = localStorage.getItem('jobWorkers');
      if (!storedWorkers) {
        setError("No job workers found in database");
        setLoading(false);
        return;
      }
      
      const workers = JSON.parse(storedWorkers);
      const workerData = workers.find(w => w.id === parseInt(id));
      
      if (workerData) {
        setWorker(workerData);
      } else {
        setError("Job worker not found");
      }
    } catch (err) {
      console.error("Error fetching job worker details:", err);
      setError("Failed to load job worker details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    fetchWorkerDetails();
  };

  if (loading) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Job Worker Details</h2>
        <Row>
          <Col>
            <div className="text-center py-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p className="mt-3">Loading job worker details...</p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error || !worker) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Job Worker Details</h2>
        <Row>
          <Col>
            <div className="not-found-box">
              <p className="mb-3">{error || "Job worker not found."}</p>
              <div className="d-flex justify-content-center gap-3">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                  Back
                </Button>
                <Button variant="primary" onClick={handleRetry}>
                  Retry
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">Job Worker Details</h2>
       
      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-details-table-wrapper">
            <table className="customer-view-table" role="table" aria-label={`Details for ${worker.name}`}>
              <tbody>
                <tr>
                  <td className="field-cell">Worker Name</td>
                  <td className="value-cell">{worker.name}</td>
                </tr>

                <tr>
                  <td className="field-cell">Phone Number</td>
                  <td className="value-cell">{worker.phoneNo || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Address</td>
                  <td className="value-cell">{worker.address || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">City</td>
                  <td className="value-cell">{worker.city || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Pin Code</td>
                  <td className="value-cell">{worker.pin_code || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewJobWorker;